import _copyPrototypeMethods from "./copy-prototype-methods";
var exports = {};
var copyPrototype = _copyPrototypeMethods;
exports = copyPrototype(Object.prototype);
export default exports;